const SINGLE = 'single'
const SUBSCRIPTION = 'subscription'

export default {
    SINGLE: SINGLE,
    SUBSCRIPTION: SUBSCRIPTION
}
